import { h, createContext } from 'preact';
import { useContext } from 'preact/hooks';
const TrackingContext = createContext(null);
export function TrackingProvider({ value, children }) {
    return h(TrackingContext.Provider, { value: value }, children);
}
/**
 * Read the current surface's tracking context. Returns `null` when no
 * provider is mounted (e.g. a card rendered in a test harness or storybook).
 * Call sites should guard with `if (!ctx) return;` rather than throw — a
 * missing provider should never crash a render.
 */
export function useTrackingContext() {
    return useContext(TrackingContext);
}
